import React, { useState } from 'react'
import { TextBold, TextRegular, TextSemiBold } from './TextStyling'
import {
  Badge,
  Divider,
  Grid,
  Paper,
  useTheme,
  useMediaQuery
} from '@mui/material'
import { colorWithOpacity, formatNumber } from '../utils/AppHelper'
import { currencySymbol } from '../utils/AppConstants'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import appassets from '../utils/appassets'
import { useNavigate } from 'react-router-dom'

const TabViewComponent = ({ tabs, style = {}, rowsData }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [activeTab, setActiveTab] = useState(tabs[0].id)
  const matches = useMediaQuery(theme.breakpoints.down('sm')) // Detect small screens
  const handleTabClick = tabId => {
    setActiveTab(tabId)
  }

  const navigate = useNavigate()

  // return
  // matches ? (
  //   <>
  //     <Paper
  //       elevation={3}
  //       style={{
  //         borderRadius: '16px',
  //         marginTop: '16px',
  //         background: colorWithOpacity(theme.palette.primary.main, 0.7)
  //       }}
  //       onClick={() =>
  //         navigate('/recruiter/earningsList', {
  //           state: { rowData: rowsData.potentialReferrals, payment: false }
  //         })
  //       }
  //     >
  //       <Grid container>
  //         <Grid
  //           item
  //           xs={9}
  //           style={{ padding: '16px', display: 'flex', alignItems: 'center' }}
  //         >
  //           <Grid container>
  //             <Grid item xs={12}>
  //               <TextBold
  //                 style={{
  //                   color: theme.palette.background.paper
  //                 }}
  //               >
  //                 Potensial referral earnings
  //               </TextBold>
  //             </Grid>

  //             <Divider
  //               style={{
  //                 width: '100%',
  //                 background: theme.palette.background.paper,
  //                 margin: '6px 0px'
  //               }}
  //             />
  //             <Grid item xs={12}>
  //               <TextRegular
  //                 style={{
  //                   color: theme.palette.background.paper,
  //                   display: 'flex',
  //                   alignItems: 'center'
  //                 }}
  //               >
  //                 Get paid <KeyboardArrowRightIcon />
  //               </TextRegular>
  //             </Grid>
  //           </Grid>
  //         </Grid>
  //         <Grid item xs={3}>
  //           <Grid
  //             item
  //             xs={2}
  //             style={{
  //               borderRadius: '16px',
  //               display: 'flex',
  //               justifyContent: 'center',
  //               alignItems: 'center',
  //               backgroundColor: colorWithOpacity(
  //                 theme.palette.background.paper,
  //                 0.7
  //               ),
  //               padding: '1rem 1.5rem',
  //               margin: '1rem'
  //             }}
  //           >
  //             <img src={appassets.recruiterSignupDollar} alt={'img'} />
  //             {/* <WalletIcon style={{ color: theme.palette.primary.main }} /> */}
  //           </Grid>
  //         </Grid>
  //       </Grid>
  //     </Paper>
  //     <Paper
  //       elevation={3}
  //       style={{
  //         borderRadius: '16px',
  //         marginTop: '16px',
  //         background: colorWithOpacity(theme.palette.primary.main, 0.7)
  //       }}
  //       onClick={() =>
  //         navigate('/recruiter/earningsList', {
  //           state: { rowData: rowsData.successfulReferrals, payment: true }
  //         })
  //       }
  //     >
  //       <Grid container>
  //         <Grid
  //           item
  //           xs={9}
  //           style={{ padding: '16px', display: 'flex', alignItems: 'center' }}
  //         >
  //           <Grid container>
  //             <Grid item xs={12}>
  //               <TextBold
  //                 style={{
  //                   color: theme.palette.background.paper
  //                 }}
  //               >
  //                 Successful referral earnings
  //               </TextBold>
  //             </Grid>

  //             <Divider
  //               style={{
  //                 width: '100%',
  //                 background: theme.palette.background.paper,
  //                 margin: '6px 0px'
  //               }}
  //             />
  //             <Grid item xs={12}>
  //               <TextRegular
  //                 style={{
  //                   color: theme.palette.background.paper,
  //                   display: 'flex',
  //                   alignItems: 'center'
  //                 }}
  //               >
  //                 Earned <KeyboardArrowRightIcon />
  //               </TextRegular>
  //             </Grid>
  //           </Grid>
  //         </Grid>
  //         <Grid item xs={3}>
  //           <Grid
  //             item
  //             xs={2}
  //             style={{
  //               borderRadius: '16px',
  //               display: 'flex',
  //               justifyContent: 'center',
  //               alignItems: 'center',
  //               backgroundColor: colorWithOpacity(
  //                 theme.palette.background.paper,
  //                 0.7
  //               ),
  //               padding: '1rem 1.5rem',
  //               margin: '1rem'
  //             }}
  //           >
  //             <img src={appassets.recruiterSignupDollar} alt={'img'} />
  //             {/* <WalletIcon style={{ color: theme.palette.primary.main }} /> */}
  //           </Grid>
  //         </Grid>
  //       </Grid>
  //     </Paper>
  //   </>
  // ) :
  return (
    <div
      style={{
        width: '100%',
        ...style
      }}
    >
      <div
        style={{
          display: 'flex',
          overflow: 'auto',
          padding: '10px 0'
        }}
      >
        {tabs.map((tab, i) => {
          var isActive = tab.id === activeTab
          return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {i !== 0 && (
                <Divider
                  orientation='vertical'
                  style={{
                    background: theme.palette.text.disabled,
                    width: 2,
                    height: '16px',
                    marginLeft: isMobile ? '20px' : '24px',
                    marginRight: isMobile ? '20px' : '24px'
                  }}
                />
              )}
              <TextRegular
                key={tab.id}
                style={{
                  fontSize: isMobile ? '15px' : '16px',
                  whiteSpace: 'nowrap',
                  cursor: 'pointer',
                  color: isActive
                    ? theme.palette.primary.main
                    : theme.palette.text.disabled
                }}
                onClick={() => handleTabClick(tab.id)}
              >
                {tab.label}
              </TextRegular>
              <Badge
                badgeContent={tab.badge}
                sx={{
                  '& .MuiBadge-badge': { fontSize: 9, width: 15, height: 15 }
                }}
                color='primary'
                style={{ left: 10, top: -8 }}
              />
            </div>
          )
        })}
      </div>
      <div style={{ paddingTop: '24px' }}>
        {tabs.find(tab => tab.id === activeTab).content}
      </div>
    </div>
  )
}

export default TabViewComponent
